var map = {
	"./about.jpg": "f84f",
	"./clipboard.jpg": "84bd",
	"./contact.jpg": "a8ac",
	"./economy.jpg": "724d",
	"./home.jpg": "3738",
	"./plans.jpg": "405c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da26";